import '@fountain/ripple/styles';

import { OpenAPI } from 'api-clients/monolith';
import React from 'react';
import ReactDOM from 'react-dom';

import { domainMeta } from 'utils/domainMeta';

import { getDirection, setBodyDirection } from './direction';
import { Root } from './root';

// Load Direction settings
const direction = getDirection();
setBodyDirection(direction);

// Setup OpenApi client
OpenAPI.BASE = domainMeta.monolithOrigin;

const MOUNT_NODE = document.getElementById('app');

ReactDOM.render(
  <React.StrictMode>
    <Root />
  </React.StrictMode>,
  MOUNT_NODE,
);
